export const svgCorrectColor = (iconName: string) =>
  document
    .querySelectorAll(`.bo-icon__item--${iconName}`)
    ?.forEach(item => item.children[0]?.setAttribute('stroke', 'currentColor'));
